import { createSelector } from '@reduxjs/toolkit';
import { constants } from 'config/constants';

//📌 Selector for get all categories from current profile.
export const selectCategories = createSelector(
	[(state) => state.Categories.data, (state) => state.Auth.selectedProfile.orgID],
	(categoriesData, orgID) => categoriesData[orgID] || []
);

//📌 Selector for get fields of category by categoryID.
export const selectCategoryFieldsByCategoryID = createSelector(
	[(state) => state.Categories.data, (state) => state.Auth.selectedProfile.orgID, (_, categoryID) => categoryID],
	(categoriesData, orgID, categoryID) =>
		(categoriesData[orgID] || []).find((category) => category.categoryID === categoryID)?.fields || []
);

// 📌 Selector to get all categories for lockers dashboard, filtered by defaultCategoryID.
export const selectCategoriesLockersDashboard = createSelector(
	[(state) => state.Categories.data, (state) => state.Auth.selectedProfile.orgID],
	(categoriesData, orgID) => {
		// Get categories for the current org and filter by defaultCategoryID
		return (categoriesData[orgID] || []).filter(
			(category) => category.defaultCategoryID === constants.ZEZAMII_LOCKERS
		);
	}
);

//📌 Selector for get category by categoryID.
export const selectCategoriesByCategoryID = createSelector(
	[(state) => state.Categories.data, (state) => state.Auth.selectedProfile.orgID, (_, categoryID) => categoryID],
	(categoriesData, orgID, categoryID) =>
		(categoriesData[orgID] || []).find((category) => category.categoryID === categoryID) || null
);

//📌 Selector for get all categories by name.
export const selectCategoriesByName = createSelector(
	[(state) => state.Categories.data, (state) => state.Auth.selectedProfile.orgID, (_, name) => name],
	(categoriesData, orgID, name) =>
		(categoriesData[orgID] || []).filter((category) => category.name.toLowerCase().includes(name.toLowerCase())) ||
		[]
);

//📌 Selector for get all categories by defaultCategoryID.
export const selectCategoriesByDefaultCategoryID = createSelector(
	[
		(state) => state.Categories.data,
		(state) => state.Auth.selectedProfile.orgID,
		(_, defaultCategoryID) => defaultCategoryID
	],
	(categoriesData, orgID, defaultCategoryID) =>
		(categoriesData[orgID] || []).filter((category) => category.defaultCategoryID === defaultCategoryID) || []
);

export const selectLockersCategories = createSelector(
	[(state) => state.Categories.data, (state) => state.Auth.selectedProfile.orgID],
	(categoriesData, orgID) => {
		const allCategories = categoriesData[orgID] || [];
		return allCategories.filter((category) => constants.BOOKEABLE_LOCKERS.includes(category.defaultCategoryID));
	}
);
